const SET_CARD_LIST = (state, data) => {
  state.cardList = data;
};

const SET_CARD_LIMITS = (state, data) => {
  state.cardLimits = data;
};

const SET_BINDING_DETAILS = (state, data) => {
  state.bindingDetails = data;
};

export default {
  SET_CARD_LIST,
  SET_CARD_LIMITS,
  SET_BINDING_DETAILS,
};
